import axios from "axios";

const BASE_URL_PROD = process.env.REACT_APP_BASE_URL;
const BASE_URL_DEV = process.env.REACT_APP_BASE_URL_DEV;
const BASE_URL_MIGRATION = process.env.REACT_APP_BASE_URL_MIGRATION;
const IMAGE_PREFIX_PROD = process.env.REACT_APP_BASE_CLOUD_PREFIX_PROD;
const IMAGE_PREFIX_MIGRATION = process.env.REACT_APP_BASE_CLOUD_PREFIX;

export const APP_STORE_URL_NC = process.env.REACT_APP_APP_STORE_URL_NC;
export const APP_STORE_URL_NF = process.env.REACT_APP_APP_STORE_URL_NF;
export const PLAY_STORE_URL_NC = process.env.REACT_APP_PLAY_STORE_URL_NC;
export const PLAY_STORE_URL_NF = process.env.REACT_APP_PLAY_STORE_URL_NF;

export const baseURL = BASE_URL_MIGRATION;
export const ImagePrefix = IMAGE_PREFIX_MIGRATION;

const axiosInstance = axios.create({
  baseURL,
});

// Request interceptor to modify requests or handle errors
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify request config if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
